import { ImagesHolder } from "../../image_loader/images_holder.js";
import { ImgID } from "../../image_loader/img_id.js";
import { CornerSizes, NineSliceDrawer } from "../../image_loader/nine_slicer/nine_slice_drawer.js";
import { UIElement } from "./ui_element.js";
import { TransformOptions } from "./ui_element.js";

export class UINineSliceElement extends UIElement
{
  private img_id: ImgID;
  private ns_key: string;
  private corner_size?: CornerSizes;
  private flip_x = false;
  private square_right = false;

  constructor(
    ctx: CanvasRenderingContext2D,
    x: number,
    y: number,
    width: number,
    height: number,
    img_id: ImgID,
    ns_key: string,
    corner_size?: CornerSizes,
    options?: TransformOptions,
    is_scalable_on_click = false,
    square_right = false,
  )
  {
    super( ctx, x, y, width, height, false, is_scalable_on_click, options );
    this.img_id = img_id;
    this.ns_key = ns_key;
    this.corner_size = corner_size;
    this.square_right = square_right;
  }

  public setImgId( img_id: ImgID, ns_key?: string ): void
  {
    this.img_id = img_id;
    if ( ns_key !== undefined )
      this.ns_key = ns_key;
  }

  public setFlipX( value: boolean ): void
  {
    this.flip_x = value;
    this.setShouldBeRendered();
  }

  public name(): string
  {
    return "UINineSliceElement";
  }

  public getX(): number
  {
    return this.rect.getX();
  }

  public getY(): number
  {
    return this.rect.getY();
  }

  public setHeight( height: number ): void
  {
    this.rect.resize( this.rect.getW(), height );
    this.setShouldBeRendered();
  }

  public render(): void
  {
    if ( !this.shouldBeRendered() )
      return;

    this.startRender();

    const x = -this.rect.getW2();
    const y = -this.rect.getH2();
    const w = this.rect.getW();
    const h = this.rect.getH();

    this.applyTransform();

    if ( this.flip_x )
      this.ctx.scale( -1, 1 );

    if ( this.square_right )
    {
      // Draw the regular right cap beyond the visible bounds and clip it off.
      // This preserves the asset's rounded left end and middle styling while
      // producing a clean vertical edge on the right.
      this.ctx.beginPath();
      this.ctx.rect( x, y, w, h );
      this.ctx.clip();
    }

    NineSliceDrawer.drawNineSliceImage(
      this.ctx,
      ImagesHolder.getImage( this.img_id ),
      this.ns_key,
      x,
      y,
      this.square_right ? w + h : w,
      h,
      this.corner_size
    );

    this.finishRender();
  }
}
